<template>
  <v-container fluid class="pa-0 pb-8">
    <v-container class="container-custom">
      <Breadcrumbs
        :title="$t('modules.portalalumno.procedures.procedureHistory.title')"
        :description="$t('modules.portalalumno.procedures.procedureHistory.description')"
      ></Breadcrumbs>
      <v-row justify="center">
        <v-col class="viewSpaces" cols="12">
          <SimpleTable
            :headers="headers"
            :items="procedureData.concat(procedureDataNew)"
            :pageCount="pagination.pagesAmount"
            :page="pagination.currentPage"
            :totalItems="procedureData.length + procedureDataNew.length"
            :status="status"
            :items-per-page="pagination.itemsPerPage"
            @clickRow="clickRow"
            @lengthPaginationChange="changePagesAmount"
          />
        </v-col>
      </v-row>
    </v-container>
    <TemporaryRightDrawer
      @tmpDrawerOpen="openDrawer"
      :open="procedureDetailDrawer.open"
      :title="procedureDetailDrawer.title"
      :description="procedureDetailDrawer.description"
      :width="75"
    >
      <ProcedureHistoryDetails :procedureId="procedureDetailDrawer.id"></ProcedureHistoryDetails>
    </TemporaryRightDrawer>
     <ModalRequestStatic
        v-if="showModalStatic"
        @cancelSendRequest="cancelarHandler"
        :tipoTramiteStatic="tipoTramiteStatic"
        :opcionesTipoTramite="opcionesTipoTramite"
        :comentarioStatic="comentarioStatic"
        :descripcionStatic="descripcionStatic"
        :costoStatic="costoStatic"
      />
  </v-container>
</template>

<script>
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs'
import TemporaryRightDrawer from '@/components/TemporaryRightDrawer/TemporaryRightDrawer'
import ProcedureHistoryDetails from './ProcedureHistoryDetails'
import SimpleTable from '../Components/SimpleTable/SimpleTable';
import moment from 'moment'
import { $studentProcessing, $student } from '../services';
import { mapGetters } from 'vuex'
import ModalRequestStatic from '../Components/ModalRequestStatic/ModalRequestStatic.vue'

export default {
  name: 'ProcedureHistory',
  components: {
    Breadcrumbs,
    SimpleTable,
    TemporaryRightDrawer,
    ProcedureHistoryDetails,
    ModalRequestStatic
  },
  data() {
    return {
      pagination: {
        limit: 20,
        page: 1,
        currentPage: 1,
        itemsPerPage: 20,
        pagesAmount: 1,
      },
      showModalStatic: false,
      headers: [
        { value: 'id', text: this.$t('modules.portalalumno.procedures.procedureHistory.table.headers.number'), align: 'center' },
        { value: 'title', text: this.$t('modules.portalalumno.procedures.procedureHistory.table.headers.name') },
        { value: 'date', text: this.$t('modules.portalalumno.procedures.procedureHistory.table.headers.date'), align: 'center' },
        { value: 'status', text: this.$t('modules.portalalumno.procedures.procedureHistory.table.headers.status'), align: 'center' }
      ],
      status: [
        { value: 'success', text: this.$t('modules.portalalumno.procedures.procedureHistory.table.status.aproved') },
        { value: 'orange', text: this.$t('modules.portalalumno.procedures.procedureHistory.table.status.observed') },
        { value: 'error', text: this.$t('modules.portalalumno.procedures.procedureHistory.table.status.rejected') },
        { value: '#419bf9', text: this.$t('modules.portalalumno.procedures.procedureHistory.table.status.init') }
      ],
      procedureData: [],
      procedureDataNew: [],
      procedureDetailDrawer: {
        open: false,
        title: '',
        description: '',
        id: null,
      },
      tipoTramiteStatic: '',
      opcionesTipoTramite: [],
      comentarioStatic: '',
      costoStatic: '',
      descripcionStatic: '',
      studentRequests:[]
    }
  },
  computed: {
    ...mapGetters({
      studentId: 'commons/getStudentId',
    }),
  },
  mounted() {
    this.fetchProcedures();
    this.fetchProceduresDoc();
    this.fetchStudentRequest();
  },
  methods: {
    openDrawer() {
      this.procedureDetailDrawer.open = !this.procedureDetailDrawer.open
      if (!this.procedureDetailDrawer.open) this.procedureDetailDrawer.id = null
    },
    changePagesAmount(value) {
      this.pagination.itemsPerPage = value;
      this.pagination.pagesAmount = Math.ceil(this.procedureData.length / value);
    },
    async fetchProcedures() {
      try {
        const responseHistory = await $student.getStudentRequest(`${this.studentId}`);
        const historyData = responseHistory.data.map(item => ({
          id: item.id,
          title: item.billing_Name,
          date: moment(item.request_Date, 'YYYY-MM-DD').format('DD/MM/YYYY'),
          status: 'Solicitado',
          source: 'history'
        }));

        this.procedureData = [...historyData];
      } catch (error) {
        this.$store.dispatch('commons/openPopUp', {
            title: this.$t('actions.error'),
            content: [{value: (error.codeMeaning != '') ? error.codeMeaning : this.$t('Ocurrió un error')}],
            actionPrimary: { text: this.$t('actions.accept'), callback() { }},
            icon: { color: 'error', name: 'mdi-close' },
            color: 'primary'
            });
      }
    },
    async fetchProceduresDoc() {
      const responseProcedures = await $studentProcessing.find(null, null, { params: { idStudent: this.studentId, page: 0, length: 100 } });
      const proceduresData = responseProcedures.data.content
        .filter(procedure => procedure.processingCategory.id !== 3)
        .map(procedure => ({
          id: procedure.id,
          title: procedure.description,
          date: moment(procedure.created, 'YYYY-MM-DD').format('DD/MM/YYYY'),
          status: procedure.processingStatus.meaning === this.$t('modules.portalalumno.procedures.procedureHistory.processingStatus.pendiente') ? this.$t('modules.portalalumno.procedures.procedureHistory.processingStatus.iniciado') : procedure.processingStatus.meaning,
          source: 'procedures'
        }));
      this.procedureDataNew = [...proceduresData];
    },
    fetchStudentRequest() {
        $student.getStudentRequest(`${this.studentId}`)
        .then(response => {
            const allRequests = response.data;

            allRequests.sort((a, b) => new Date(b.request_Date) - new Date(a.request_Date));

            this.studentRequests = allRequests;
        })
        .catch(error => {
           this.$store.dispatch('commons/openPopUp', {
            title: this.$t('actions.error'),
            content: [{value: (error.codeMeaning != '') ? error.codeMeaning : this.$t('Ocurrió un error')}],
            actionPrimary: { text: this.$t('actions.accept'), callback() { }},
            icon: { color: 'error', name: 'mdi-close' },
            color: 'primary'
          });
        });
    },
    cancelarHandler() {
      this.showModalStatic = false;
    },
   async clickRow($event) {
    if ($event.source === 'history') {
      const matchedHistoryItem = this.studentRequests.find(item => item.id == $event.id);
      await this.fetchStudentRequest();
      if (matchedHistoryItem) {
        this.tipoTramiteStatic = matchedHistoryItem.billing_Name;
        this.comentarioStatic = matchedHistoryItem.student_Comments;
        this.costoStatic = matchedHistoryItem.default_Price;
        this.descripcionStatic = matchedHistoryItem.billing_Product_Description;
        this.showModalStatic = true;
      } else {
        this.$store.dispatch('commons/openPopUp', {
            title: this.$t('actions.error'),
            content: [this.$t('Ocurrió un error')],
            actionPrimary: { text: this.$t('actions.accept'), callback() { }},
            icon: { color: 'error', name: 'mdi-close' },
            color: 'primary'
            });
      }
  } else if ($event.source === 'procedures') {
    this.fetchProceduresDoc();
    this.procedureDetailDrawer.title = $event.title;
    this.procedureDetailDrawer.description = `${this.$t('modules.portalalumno.procedures.procedureHistory.tramite')} № ${$event.id} - ${this.$t('modules.portalalumno.procedures.procedureHistory.fechaSolicitud')} ${$event.date}`;
    this.procedureDetailDrawer.open = true;
    this.procedureDetailDrawer.id = $event.id;
  } else {
    this.$store.dispatch('commons/openPopUp', {
    title: this.$t('actions.error'),
    content: [this.$t('Ocurrió un error')],
    actionPrimary: { text: this.$t('actions.accept'), callback() { }},
    icon: { color: 'error', name: 'mdi-close' },
    color: 'primary'
    });
  }
  },
  }
}
</script>